/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/auth/auth-guard.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { User } from "./user";
import * as i0 from "@angular/core";
import * as i1 from "./user";
import * as i2 from "@angular/router";
export class AuthGuardService {
    /**
     * @param {?} user
     * @param {?} router
     */
    constructor(user, router) {
        this.user = user;
        this.router = router;
    }
    /**
     * @param {?} route
     * @return {?}
     */
    canActivate(route) {
        if (!this.user.isAuthenticated()) {
            this.router.navigate(['login']);
            return false;
        }
        return true;
    }
}
AuthGuardService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] },
];
/** @nocollapse */
AuthGuardService.ctorParameters = () => [
    { type: User },
    { type: Router }
];
/** @nocollapse */ AuthGuardService.ɵfac = function AuthGuardService_Factory(t) { return new (t || AuthGuardService)(i0.ɵɵinject(i1.User), i0.ɵɵinject(i2.Router)); };
/** @nocollapse */ AuthGuardService.ɵprov = i0.ɵɵdefineInjectable({ token: AuthGuardService, factory: AuthGuardService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AuthGuardService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1.User }, { type: i2.Router }]; }, null); })();
if (false) {
    /** @type {?} */
    AuthGuardService.prototype.user;
    /** @type {?} */
    AuthGuardService.prototype.router;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aC1ndWFyZC5zZXJ2aWNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vdmlzaW9uaWNzL25nL3NyYy9hcHAvYXV0aC9hdXRoLWd1YXJkLnNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxPQUFPLEVBQUMsVUFBVSxFQUFDLE1BQU0sZUFBZSxDQUFDO0FBQ3pDLE9BQU8sRUFBc0MsTUFBTSxFQUFDLE1BQU0saUJBQWlCLENBQUM7QUFFNUUsT0FBTyxFQUFDLElBQUksRUFBQyxNQUFNLFFBQVEsQ0FBQzs7OztBQUs1QixNQUFNLE9BQU8sZ0JBQWdCOzs7OztJQUMzQixZQUFtQixJQUFVLEVBQVMsTUFBYztRQUFqQyxTQUFJLEdBQUosSUFBSSxDQUFNO1FBQVMsV0FBTSxHQUFOLE1BQU0sQ0FBUTtJQUFHLENBQUM7Ozs7O0lBQ3hELFdBQVcsQ0FBQyxLQUE2QjtRQUN2QyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxlQUFlLEVBQUUsRUFBRTtZQUNoQyxJQUFJLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFFLE9BQU8sQ0FBRSxDQUFDLENBQUM7WUFDbEMsT0FBTyxLQUFLLENBQUM7U0FDZDtRQUNELE9BQU8sSUFBSSxDQUFDO0lBQ2QsQ0FBQzs7O1lBWEYsVUFBVSxTQUFDO2dCQUNWLFVBQVUsRUFBRyxNQUFNO2FBQ3BCOzs7O1lBSk8sSUFBSTtZQUZpQyxNQUFNOztnRkFPdEMsZ0JBQWdCO3dEQUFoQixnQkFBZ0IsV0FBaEIsZ0JBQWdCLG1CQUZkLE1BQU07a0RBRVIsZ0JBQWdCO2NBSDVCLFVBQVU7ZUFBQztnQkFDVixVQUFVLEVBQUcsTUFBTTthQUNwQjs7OztJQUVhLGdDQUFpQjs7SUFBRSxrQ0FBcUIiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge0luamVjdGFibGV9IGZyb20gJ0Bhbmd1bGFyL2NvcmUnO1xuaW1wb3J0IHtBY3RpdmF0ZWRSb3V0ZVNuYXBzaG90LCBDYW5BY3RpdmF0ZSwgUm91dGVyfSBmcm9tICdAYW5ndWxhci9yb3V0ZXInO1xuXG5pbXBvcnQge1VzZXJ9IGZyb20gXCIuL3VzZXJcIjtcblxuQEluamVjdGFibGUoe1xuICBwcm92aWRlZEluIDogJ3Jvb3QnLFxufSlcbmV4cG9ydCBjbGFzcyBBdXRoR3VhcmRTZXJ2aWNlIGltcGxlbWVudHMgQ2FuQWN0aXZhdGUge1xuICBjb25zdHJ1Y3RvcihwdWJsaWMgdXNlcjogVXNlciwgcHVibGljIHJvdXRlcjogUm91dGVyKSB7fVxuICBjYW5BY3RpdmF0ZShyb3V0ZTogQWN0aXZhdGVkUm91dGVTbmFwc2hvdCk6IGJvb2xlYW4ge1xuICAgIGlmICghdGhpcy51c2VyLmlzQXV0aGVudGljYXRlZCgpKSB7XG4gICAgICB0aGlzLnJvdXRlci5uYXZpZ2F0ZShbICdsb2dpbicgXSk7XG4gICAgICByZXR1cm4gZmFsc2U7XG4gICAgfVxuICAgIHJldHVybiB0cnVlO1xuICB9XG59XG4iXX0=